import { KalturaPurchaseStatus } from '@kaltura-ott/ott-client-types/api/types';

import type { MediaType } from '../lib/dms';
import type { KuxImages } from '../lib/utils/image';
import { KuxCategoryMetas, KuxMultiTags } from '../lib/utils/meta';

export const MAX_EPG_PERIOD = 7; // 7 days

/**
 *  Video Playout
 *  DEPRECATED
 */
export interface KuxChannel {
  adult: boolean;
  channelNumber: number;
  catchUpBuffer: number;
  id: number;
  images: KuxImages;
  isFavorite?: boolean;
  isPurchased: boolean;
  isPurchasePending?: boolean;
  mediaFileId?: number;
  originImage?: string;
  parentalRating: number;
  representPackage?: boolean;
  title: string;
  watchedCount?: number;
  purchaseStatus?: KalturaPurchaseStatus;
}
/* DEPRECATED */
export interface KuxProgram {
  adult: boolean;
  description: string;
  enableCatchUp: boolean;
  enableCdvr: boolean;
  enableStartOver: boolean;
  enableTrickPlay: boolean;
  endDate: number;
  epgId: string;
  id: number;
  images: KuxImages;
  linearAssetId: number;
  metas: KuxCategoryMetas;
  notFound?: boolean;
  originImage?: string;
  parentalRating: number;
  recordable: boolean;
  startDate: number;
  tags: KuxMultiTags;
  title: string;
  type: number;
  mediaType?: MediaType;
}
